import styled, { CSSObject } from 'styled-components';

import { Text } from '@components/text';
import { Color, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type ChatBubbleProps = {
  color: Color;
  text: string;
  direction: 'left' | 'right';
  backgroundColor?: Color;
};

export const ChatBubble = (props: ChatBubbleProps) => {
  const { color, text, direction, backgroundColor } = props;

  return (
    <StyledChatBubble color={color} direction={direction} backgroundColor={backgroundColor}>
      <Text text={text} color="white100" font="semibold14" />
    </StyledChatBubble>
  );
};

type StyledChatBubbleProps = {
  color: Color;
  direction: 'left' | 'right';
  backgroundColor?: Color;
};

const StyledChatBubble = styled.div<StyledChatBubbleProps>(
  (props: StyledChatBubbleProps): CSSObject => ({
    width: 'fit-content',
    maxWidth: '80%',
    wordWrap: 'break-word',
    position: 'relative',
    padding: pxToRem(16),
    borderRadius: pxToRem(25),
    backgroundColor: theme.color[props.color],

    '&:before': {
      content: "''",
      position: 'absolute',
      bottom: 0,
      height: pxToRem(25),
      width: pxToRem(20),
      backgroundColor: theme.color[props.color],
      left: props.direction === 'left' ? pxToRem(-7) : undefined,
      right: props.direction === 'right' ? pxToRem(-7) : undefined,
      borderBottomRightRadius:
        props.direction === 'left' ? `${pxToRem(16)} ${pxToRem(14)}` : undefined,
      borderBottomLeftRadius:
        props.direction === 'right' ? `${pxToRem(16)} ${pxToRem(14)}` : undefined,
    },

    '&:after': {
      content: "''",
      position: 'absolute',
      bottom: 0,
      height: pxToRem(25),
      width: pxToRem(8),
      backgroundColor: props.backgroundColor
        ? theme.color[props.backgroundColor]
        : theme.color.white100,
      left: props.direction === 'left' ? pxToRem(-8) : undefined,
      right: props.direction === 'right' ? pxToRem(-8) : undefined,
      borderBottomRightRadius: props.direction === 'left' ? pxToRem(10) : undefined,
      borderBottomLeftRadius: props.direction === 'right' ? pxToRem(10) : undefined,
    },
  }),
);
